// extracted by mini-css-extract-plugin
module.exports = {"layout":"Container_layout__DCEom","cardContainer":"Container_cardContainer___MAUA","offersWrapper":"Container_offersWrapper__jXiuw"};